import { GlobalService } from 'src/app/global.service';
import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';
import { BillAlertComponent } from '../bill-alert/bill-alert.component';
import { COMMA, ENTER } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-instition-bill',
  templateUrl: './instition-bill.component.html',
  styleUrls: ['./instition-bill.component.scss']
})
export class InstitionBillComponent implements OnInit {
  from_date: any;
  to_date: any;
  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  seleted_option_type: any = 'by_business_type';
  business_type_list = [];
  business_list = [];
  selected_product_option: any = null;
  entered_booth_number: any = null;
  title: any;
  today = new Date().toISOString().split('T')[0];
  exclude_booth_code_list = [];
  business_type_wise_booth: any;
  visible = true;
  removable = true;
  selectable = true;
  entered_booth_code_for_exclude = null;
  separatorKeysCodes: number[] = [ENTER, COMMA];

  constructor(private httpService: HttpService, private dialog: MatDialog, private global: GlobalService) {
    this.title = this.global._active_display_name;
    // this.httpService.serveBusinessTypeWiseBooth().subscribe((data) => {
    //   console.log(data);
    //   this.business_type_wise_booth = data;
    // }, (error) => {
    //   console.error(error);
    // });
  }

  addNewBoothCalledForExclude() {
    if (this.entered_booth_code_for_exclude !== null && this.entered_booth_code_for_exclude !== '') {
      this.exclude_booth_code_list.push(this.entered_booth_code_for_exclude.trim());
    }
    this.entered_booth_code_for_exclude = null;
  }

  removeBoothCalled(booth_value) {
    let index = this.exclude_booth_code_list.map((element) => {
      return element;
    }).indexOf(booth_value);
    this.exclude_booth_code_list.splice(index, 1);
  }

  openAlert(data) {
    const dialogRef = this.dialog.open(BillAlertComponent, {
      height: '700px',
      width: '700px',
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      if (res) {
      }
    });
  }

  getClicked() {
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date,
      'option_type': this.seleted_option_type,
      'business_type_list': this.business_type_list,
      'exclude_booth_code': this.exclude_booth_code_list
    };
    if (this.seleted_option_type === 'by_business_type') {
      if (this.business_type_list.length === 0) {
        alert('Please Fill Booth number or Institution Type');
        return false;
      }
    } else {
      if (this.entered_booth_number == null || this.entered_booth_number === '') {
        alert('Please Fill Booth number or Institution Type');
        return false;
      }
    }
    if (this.seleted_option_type === 'by_business') {
      let booth_list = this.entered_booth_number.split(',');
      data_dict['business_code_list'] = booth_list;
    }
    console.log(data_dict);
    if (this.selected_product_option === 'milk') {
      this.is_document_available = false;
      this.httpService.generateInstitutionBillForMilk(data_dict).subscribe((data) => {
        this.is_document_available = true;
        console.log(data);
        if (data['is_multiple_price']) {
          this.openAlert(data);
        } else {
          this.document_file = data;
          this.is_document_available = true;
        }
      }, (error) => {
        this.is_document_available = true;
      });
    } else {
      this.is_document_available = false;
      this.httpService.generateInstitutionBillForCurd(data_dict).subscribe((data) => {
        this.is_document_available = true;
        console.log(data);
        if (data['is_multiple_price']) {
          this.openAlert(data);
        } else {
          this.is_document_available = true;
          if (data['is_file_available']) {
            this.document_file = data;
          } else {
            alert('There is No Order Under Private Institute');
            return false
          }
        }
      }, (error) => {
        alert('Error on Bill Generation');
        this.is_document_available = true;
      });
    }
  }

  async businessTypeOptionChanged(event, type_value) {
    this.document_file = null;
    if (event['checked']) {
      this.business_type_list.push(type_value);
    } else {
      let index = this.business_type_list.map((element) => {
        return element;
      }).indexOf(type_value);
      this.business_type_list.splice(index, 1);
    }
    // await this.business_type_list.forEach(element => {
    //   this.booth_code_list.push(...this.business_type_wise_booth[element])
    // });
  }

  downloadClickedForPdf() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  downloadClickedForExcel() {
    const linkSource = 'data:application/xlsx;base64,' + this.document_file['excel'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['excel_file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  changeEvent() {
    this.document_file = null;
  }
  ngOnInit() {
  }
}
